import Vue from "vue";
import Vuex from "vuex";
import { getLocalStorageData } from "@/common/index"
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentTab: 0,
    token: "",
    userInfo: {
      phone: "",
    },
    timer: null,
    accountLockout: false,
    BarrierInfo: {},
    Energy: "",
    EnergyFlag: false,
    //是否展示过引导页面
    showGuide: false,
    //账单id列表
    billIdList: [],
    //选中的账单列表
    selectedBillList: [],
    //绑定银行卡信息
    bankCardInfo: {},
    //首页数据
    homeData: {},
    //订单详情
    orderDetails: {},
    //收款银行信息
    bankName: "",
    //消费用途
    borrowPurpose: "",
    //用户协议列表
    agreementList: [],
    //收款银行列表
    bankList: [],
    //收款银行信息
    bankInfo: {},
    //贷前检测数据
    preCheckData: {},
    routerFlag: "1",
    //黑名单用户广告
    blackListAd: {},
    //灰名单用户广告
    grayListAd: {},
    //准入广告
    admissionAd: {},
    //渠道Id channelId=2055189725761376256
    channelId: "",
    //loading状态
    loading: false,
    //绑定卡路由标注
    bankCardBindingFlag: '',
    //借款页面新增银行卡后将新卡保存为收款卡，只针对当前借款（不修改默认卡）
    receivedBank: {},
    //是否同意协议
    isChecked: false,
    //是否展示过微信引导页面
    showWechatGuide: false,
    //实名认证协议信息
    realNameProtocol: {},
    //借款协议信息
    borrowProtocol: {},
    //服务费
    serviceFee: [],
    //底部tab选中
    activedTab:getLocalStorageData('actived') || 1,
    
  },
  getters: {
    accountLockout(state) {
      return state.accountLockout;
    },
    userInfo(state) {
      return state.userInfo;
    },
    BarrierInfo(state) {
      return state.BarrierInfo;
    },
    Energy(state) {
      return state.Energy;
    },
    EnergyFlag(state) {
      return state.EnergyFlag;
    },
    showGuide(state) {
      return state.showGuide;
    },
    billIdList(state) {
      return state.billIdList;
    },
    selectedBillList(state) {
      return state.selectedBillList;
    },
    bankCardInfo(state) {
      return state.bankCardInfo;
    },
    homeData(state) {
      return state.homeData;
    },
    orderDetails(state) {
      return state.orderDetails;
    },
    bankName(state) {
      return state.bankName;
    },
    borrowPurpose(state) {
      return state.borrowPurpose;
    },
    agreementList(state) {
      return state.agreementList;
    },
    bankList(state) {
      return state.bankList;
    },
    bankInfo(state) {
      return state.bankInfo;
    },
    preCheckData(state) {
      return state.preCheckData;
    },
    routerFlag(state) {
      return state.routerFlag;
    },
    blackListAd(state) {
      return state.blackListAd;
    },
    grayListAd(state) {
      return state.grayListAd;
    },
    admissionAd(state) {
      return state.admissionAd;
    },
    channelId(state) {
      return state.channelId;
    },
    loading(state) {
      return state.loading;
    },
    bankCardBindingFlag(state) {
      return state.bankCardBindingFlag;
    },
    receivedBank(state) {
      return state.receivedBank;
    },
    //是否同意协议
    isChecked(state) {
      return state.isChecked;
    },
    //是否展示过微信引导页面
    showWechatGuide(state) {
      return state.showWechatGuide;
    },
    //实名认证协议信息
    realNameProtocol(state) {
      return state.realNameProtocol;
    },
    //借款协议信息
    borrowProtocol(state) {
      return state.borrowProtocol;
    },
    //服务费
    serviceFee(state) {
      return state.serviceFee;
    },
    //底部tab选中
    activedTab(state) {
      return state.activedTab;
    },
  },
  mutations: {
    setCurrentTab(state, currentTab) {
      state.currentTab = currentTab;
    },
    setToken(state, token) {
      state.token = token;
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    setTimer(state, timer) {
      state.timer = timer;
    },
    setAccountLockout(state, accountLockout) {
      state.accountLockout = accountLockout;
    },
    setBarrierInfo(state, BarrierInfo) {
      state.BarrierInfo = BarrierInfo;
    },
    setEnergy(state, Energy) {
      state.Energy = Energy;
    },
    setEnergyFlag(state, EnergyFlag) {
      state.EnergyFlag = EnergyFlag;
    },
    setShowGuide(state, showGuide) {
      state.showGuide = showGuide;
    },
    setBillIdList(state, billIdList) {
      state.billIdList = billIdList;
    },
    setSelectedBillList(state, selectedBillList) {
      state.selectedBillList = selectedBillList;
    },
    setBankCardInfo(state, bankCardInfo) {
      state.bankCardInfo = bankCardInfo;
    },
    setHomeData(state, homeData) {
      state.homeData = homeData;
    },
    setOrderDetails(state, orderDetails) {
      state.orderDetails = orderDetails;
    },
    setBankName(state, bankName) {
      state.bankName = bankName;
    },
    setBorrowPurpose(state, borrowPurpose) {
      state.borrowPurpose = borrowPurpose;
    },
    setAgreementList(state, agreementList) {
      state.agreementList = agreementList;
    },
    setBankList(state, bankList) {
      state.bankList = bankList;
    },
    setBankInfo(state, bankInfo) {
      state.bankInfo = bankInfo;
    },
    setPreCheckData(state, preCheckData) {
      state.preCheckData = preCheckData;
    },
    setRouterFlag(state, routerFlag) {
      state.routerFlag = routerFlag;
    },
    setBlackListAd(state, blackListAd) {
      state.blackListAd = blackListAd;
    },
    setGrayListAd(state, grayListAd) {
      state.grayListAd = grayListAd;
    },
    setAdmissionAd(state, admissionAd) {
      state.admissionAd = admissionAd;
    },
    setChannelId(state, channelId) {
      state.channelId = channelId;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setBankCardBindingFlag(state, bankCardBindingFlag) {
      state.bankCardBindingFlag = bankCardBindingFlag;
    },
    setReceivedBank(state, receivedBank){
      state.receivedBank = receivedBank;
    },
    //是否同意协议
    setIsChecked(state, isChecked) {
      state.isChecked = isChecked;
    },
    //是否展示过微信引导页面
    setShowWechatGuide(state, showWechatGuide) {
      state.showWechatGuide = showWechatGuide;
    },
    //实名认证协议信息
    setRealNameProtocol(state, realNameProtocol) {
      state.realNameProtocol = realNameProtocol;
    },
    //借款协议信息
    setBorrowProtocol(state, borrowProtocol) {
      state.borrowProtocol = borrowProtocol;
    },
    //服务费
    setServiceFee(state, serviceFee) {
      state.serviceFee = serviceFee;
    },
    //底部tab选中
    setActivedTab(state, activedTab) {
      state.activedTab = activedTab;
    },
  },
  actions: {
    //清除选中的账单列表
    clearSelectedBillList({ commit }) {
      commit("setSelectedBillList", []);
      commit("setServiceFee", []);
    },
    //清除绑定银行卡信息
    clearBankName({ commit }) {
      commit("setBankName", "");
    },
    //清除用户协议列表
    clearAgreementList({ commit }) {
      commit("setAgreementList", []);
    }

  },
  modules: {},
});
